import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { budgetAPI } from 'src/app/services/apiRoutes';
import { PaginationObject } from 'src/app/models/paginationObject';
import paginationHelper from 'src/app/helpers/pagination';
import sortHelper from 'src/app/helpers/sort';
import { SortObject } from 'src/app/models/sortObject';
import { BehaviorSubject } from 'rxjs';

@Injectable()
export class BudgetsService {

  private budgetsDashboard = new BehaviorSubject(false);
  budgetsDashboardData = this.budgetsDashboard.asObservable();

  constructor(public http: HttpClient) {}

  async getBudgets(pageInfo: PaginationObject, sortObject: SortObject[] | null, query: string) {
    return this.http
      .get(
        budgetAPI +
          paginationHelper.constructPagination(pageInfo) +
          sortHelper.constructSort(sortObject, true) +
          query
      )
      .toPromise();
  }

  fetchBudgetsDashboard(fetchOrders: boolean) {
    this.budgetsDashboard.next(fetchOrders)
  }
}
